import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { type PageContext } from '@blaze-shared/projects-domain';

export const pageContextActions = createActionGroup({
  source: 'Page Context',
  events: {
    Reset: emptyProps(),
    Set: props<{ pageContext: PageContext }>(),
    'Set for overlay': props<{ pageContext: PageContext }>(),
    'Initialize from session storage': props<{ pageContext: Record<string, PageContext> }>(),
    'Mark as loaded': emptyProps(),
    'Initialization start': emptyProps(),
    Remove: props<{ pageContextId: string }>(),
  },
});
